<template>
  <div class="datagl">
    <!-- <div class="top"> -->
    <!-- <div>
                <p>城市</p>
                <el-select v-model="city" placeholder="请选择" size="mini" filterable @change="changecity">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div> -->
    <!-- <div>
                <p>污染物类型</p>
                <el-select v-model="type1" placeholder="请选择" size="mini" filterable @change="selectwrwlx">
                    <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div> -->
    <!-- <div>
                <p>污染物</p>
                <el-cascader
                class="operateItem"
                    v-model="wrw"
                    :options="Options.wrwOptions"
                    @change="handleChangeWrw"
                    :show-all-levels="false"
                    placeholder="污染物"
                    size="medium"
                ></el-cascader>
            </div>
          -->
    <!-- <div>
                <p>年度</p>
                <div class="block">
                    <span class="demonstration"></span>
                    <el-date-picker v-model="year" type="year" placeholder="选择年" size="mini" :clearable=false
                        @change="changeYear">
                    </el-date-picker>
                </div>
            </div> -->
    <!-- <div>
                <p>健康风险指数</p>
                <el-select v-model="jkfxzs" placeholder="请选择" size="mini" filterable>
                    <el-option v-for="item in options6" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div> -->
    <!-- <el-button size="mini" @click="reset">重置</el-button> -->
    <!-- <el-button size="mini" @click="importexcel">数据更新</el-button> -->

    <!-- </div> -->
    <div class="bottom">
      <el-table :data="tableData" height="600" border style="width: 100%">
        <el-table-column prop="name" label="数据名称"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="import1(scope.row)" type="text" size="small"
              >数据更新</el-button
            >
            <el-button type="text" size="small"  @click="download(scope.row)">模板下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="数据更新" :visible.sync="dialogVisible" width="30%">
      <div class="importexcel">
        <span @click="import1(1)">更新长三角重金属浓度数据</span>
        <p @click="download(1)">请根据模板更新数据！点击下载</p>
        <span @click="import1(2)">更新社会经济因子指标数据</span>
        <p @click="download(2)">请根据模板更新数据！点击下载</p>
        <span @click="import1(3)">更新多环芳烃浓度和风险值数据</span>
        <p @click="download(3)">请根据模板更新数据！点击下载</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <input
      type="file"
      accept
      style="float: left; display: none"
      id="uploadFile"
      @change="uploadsample()"
    />
  </div>
</template>
<script>
import Options from "./HomeView/child/options";
export default {
  data() {
    return {
      Options: Options,
      wrw: [],
      token: "",
      username: "",
      options: [
        {
          value: "上海市",
          label: "上海市",
        },
        {
          value: "南京市",
          label: "南京市",
        },
        {
          value: "无锡市",
          label: "无锡市",
        },
        {
          value: "徐州市",
          label: "徐州市",
        },
        {
          value: "常州市",
          label: "常州市",
        },
        {
          value: "苏州市",
          label: "苏州市",
        },
        {
          value: "南通市",
          label: "南通市",
        },
        {
          value: "连云港市",
          label: "连云港市",
        },
        {
          value: "淮安市",
          label: "淮安市",
        },
        {
          value: "盐城市",
          label: "盐城市",
        },
        {
          value: "扬州市",
          label: "扬州市",
        },
        {
          value: "镇江市",
          label: "镇江市",
        },
        {
          value: "泰州市",
          label: "泰州市",
        },
        {
          value: "宿迁市",
          label: "宿迁市",
        },
        {
          value: "杭州市",
          label: "杭州市",
        },
        {
          value: "宁波市",
          label: "宁波市",
        },
        {
          value: "温州市",
          label: "温州市",
        },
        {
          value: "绍兴市",
          label: "绍兴市",
        },
        {
          value: "湖州市",
          label: "湖州市",
        },
        {
          value: "嘉兴市",
          label: "嘉兴市",
        },
        {
          value: "金华市",
          label: "金华市",
        },
        {
          value: "衢州市",
          label: "衢州市",
        },
        {
          value: "舟山市",
          label: "舟山市",
        },
        {
          value: "台州市",
          label: "台州市",
        },
        {
          value: "丽水市",
          label: "丽水市",
        },
        {
          value: "合肥市",
          label: "合肥市",
        },
        {
          value: "芜湖市",
          label: "芜湖市",
        },
        {
          value: "马鞍山市",
          label: "马鞍山市",
        },
        {
          value: "铜陵市",
          label: "铜陵市",
        },
        {
          value: "池州市",
          label: "池州市",
        },
        {
          value: "安庆市",
          label: "安庆市",
        },
        {
          value: "宣城市",
          label: "宣城市",
        },
        {
          value: "滁州市",
          label: "滁州市",
        },
        {
          value: "淮北市",
          label: "淮北市",
        },
        {
          value: "蚌埠市",
          label: "蚌埠市",
        },
        {
          value: "淮南市",
          label: "淮南市",
        },
        {
          value: "宿州市",
          label: "宿州市",
        },
        {
          value: "阜阳市",
          label: "阜阳市",
        },
        {
          value: "亳州市",
          label: "亳州市",
        },
        {
          value: "六安市",
          label: "六安市",
        },
        {
          value: "黄山市",
          label: "黄山市",
        },
      ],
      options2: [
        {
          value: "1",
          label: "重金属",
        },
        {
          value: "2",
          label: "有机污染物",
        },
      ],
      options3: [
        {
          value: "Cd",
          label: "Cd",
        },
        {
          value: "Pb",
          label: "Pb",
        },
        {
          value: "Cu",
          label: "Cu",
        },
        {
          value: "Zn",
          label: "Zn",
        },
        {
          value: "Ni",
          label: "Ni",
        },
      ],
      options4: [
        {
          value: "Nap",
          label: "Nap",
        },
        {
          value: "Acy",
          label: "Acy",
        },
        {
          value: "Ace",
          label: "Ace",
        },
        {
          value: "Flu",
          label: "Flu",
        },
        {
          value: "Phe",
          label: "Phe",
        },
        {
          value: "Ant",
          label: "Ant",
        },
        {
          value: "Fla",
          label: "Fla",
        },
        {
          value: "Pyr",
          label: "Pyr",
        },
        {
          value: "BaA",
          label: "BaA",
        },
        {
          value: "Chr",
          label: "Chr",
        },
        {
          value: "BbF",
          label: "BbF",
        },
        {
          value: "BkF",
          label: "BkF",
        },
        {
          value: "BaP",
          label: "BaP",
        },
        {
          value: "BghiP",
          label: "BghiP",
        },
        {
          value: "InP",
          label: "InP",
        },
      ],
      options5: [],
      options6: [
        {
          value: "优",
          label: "优",
        },
        {
          value: "良",
          label: "良",
        },
        {
          value: "中",
          label: "中",
        },
        {
          value: "差",
          label: "差",
        },
      ],
      value: "",
      jkfxzs: "",
      year: "",
      city: "",
      type1: "",
      type2: "",
      tableData: [
        {
          name: "1.2重金属每年平均数据",
          dowmLoadurl:"/exceldata/MetalAverageAnnual/download/",
          url:"/exceldata/MetalAverageAnnual/1/"

        },
        {
          name: "1.5重金属数据量",
          dowmLoadurl:"/exceldata/MetalReference/download/",
          url:"/exceldata/MetalReference/1/"
        },
        {
          name: "2.2网站2000-2030社会因子数据",
          dowmLoadurl:"/exceldata/socialeconomy/download/",
          url:"/exceldata/socialeconomy/1/"
        },
        {
          name: "3.2重金属浓度2000-2030",
          dowmLoadurl:"/exceldata/metaldensity/download/",
          url:"/exceldata/metaldensity/1/"
        },
        {
          name: "3.3.1重金属致癌2000-2030",
          dowmLoadurl:"/exceldata/metalcancerrisk/download/",
          url:"/exceldata/metalcancerrisk/1/"
        },
        {
          name: "3.3.2重金属非致癌2000-2030数据",
          dowmLoadurl:"/exceldata/MetalNonCancerRisk/download/",
          url:"/exceldata/MetalNonCancerRisk/1/"
        },
        {
          name: "1.2多环芳烃每年平均值",
          dowmLoadurl:"/exceldata/PAHsAverageAnnual/download/",
          url:"/exceldata/PAHsAverageAnnual/1/"
        },
        {
          name: "1.4土地利用面积占比",
          dowmLoadurl:"/exceldata/LandUseRatio/download/",
          url:"/exceldata/LandUseRatio/1/"
        },
        {
          name: "1.5多环芳烃数据量",
          url:"/exceldata/PAHsReference/1/",
          dowmLoadurl:"/exceldata/PAHsReference/download/",
        },
        {
          name: "4.2.1多环芳烃致癌风险2000-2030",
          url:"/exceldata/PAHsCancerRisk/1/",
          dowmLoadurl:"/exceldata/PAHsCancerRisk/download/",
        },
        {
          name: "4.2多环芳烃浓度2000-2030",
          dowmLoadurl:"/exceldata/pahsdensity/download/",
          url:"/exceldata/pahsdensity/1/"
        },
      ],
      dialogVisible: false,
      inputtype: "",
      operateObj:{}
    };
  },
  methods: {
    handleChangeWrw() {},
    // 选中污染物类型
    selectwrwlx(value) {
      if (value == 1) {
        this.options5 = this.options3;
        // this.unit = "mg/kg"
      } else if (value == 2) {
        this.options5 = this.options4;
        // this.unit = "μg/kg"
      }
      this.type2 = "";
    },
    changeYear() {
      this.getzjs();
      if (this.type1 == 1) {
        this.getzjs();
      } else if (this.type1 == 2) {
        this.getyjw();
      }
    },
    changewrw() {
      if (this.type1 == 1) {
        this.getzjs();
      } else if (this.type1 == 2) {
        this.getyjw();
      }
    },
    changecity() {
      if (this.type1 == 1) {
        this.getzjs();
      } else if (this.type1 == 2) {
        this.getyjw();
      }
    },
    // 获取重金属
    getzjs() {
      const _this = this;
      var year = new Date(this.year).getFullYear();
      this.$axios({
        method: "get",
        url: "/exceldata/metaldensity/",
        params: {
          all: 1,
          page: 1,
          city: this.city,
          year: year,
          min_year: "",
          max_year: "",
          min_cd: "",
          max_cd: "",
        },
        headers: {
          Authorization: _this.token.toString(),
        },
      }).then(function (res) {
        console.log(res);
        for (var i = 0; i < res.data.results.length; i++) {
          res.data.results[i].type1 = "重金属";
          res.data.results[i].type2 = _this.type2;
          if (_this.type2 == "Cd") {
            res.data.results[i].number = res.data.results[i].Cd;
          } else if (_this.type2 == "Pb") {
            res.data.results[i].number = res.data.results[i].Pd;
          } else if (_this.type2 == "Cu") {
            res.data.results[i].number = res.data.results[i].Cu;
          } else if (_this.type2 == "Zn") {
            res.data.results[i].number = res.data.results[i].Zn;
          } else if (_this.type2 == "Ni") {
            res.data.results[i].number = res.data.results[i].Ni;
          }
        }
        _this.tableData = res.data.results;
      });
    },
    // 获取有机物
    getyjw() {
      const _this = this;
      var year = new Date(this.year).getFullYear();
      this.$axios({
        method: "get",
        url: "/pollution/organic/compound/",
        params: {
          page_size: 100,
          page: 1,
          city: this.city,
          year: year,
          min_year: "",
          max_year: "",
          min_cd: "",
          max_cd: "",
        },
        headers: {
          Authorization: _this.token.toString(),
        },
      }).then(function (res) {
        console.log(res);
        for (var i = 0; i < res.data.results.length; i++) {
          res.data.results[i].type1 = "有机污染物";
          res.data.results[i].type2 = _this.type2;
          if (_this.type2 == "Nap") {
            res.data.results[i].number = res.data.results[i].Nap;
          } else if (_this.type2 == "Acy") {
            res.data.results[i].number = res.data.results[i].Acy;
          } else if (_this.type2 == "Ace") {
            res.data.results[i].number = res.data.results[i].Ace;
          } else if (_this.type2 == "Flu") {
            res.data.results[i].number = res.data.results[i].Flu;
          } else if (_this.type2 == "Phe") {
            res.data.results[i].number = res.data.results[i].Phe;
          } else if (_this.type2 == "Ant") {
            res.data.results[i].number = res.data.results[i].Ant;
          } else if (_this.type2 == "Fla") {
            res.data.results[i].number = res.data.results[i].Fla;
          } else if (_this.type2 == "Pyr") {
            res.data.results[i].number = res.data.results[i].Pyr;
          } else if (_this.type2 == "BaA") {
            res.data.results[i].number = res.data.results[i].BaA;
          } else if (_this.type2 == "Chr") {
            res.data.results[i].number = res.data.results[i].Chr;
          } else if (_this.type2 == "BbF") {
            res.data.results[i].number = res.data.results[i].BbF;
          } else if (_this.type2 == "BkF") {
            res.data.results[i].number = res.data.results[i].BkF;
          } else if (_this.type2 == "BaP") {
            res.data.results[i].number = res.data.results[i].BaP;
          } else if (_this.type2 == "BghiP") {
            res.data.results[i].number = res.data.results[i].DahA;
          } else if (_this.type2 == "InP") {
            res.data.results[i].number = res.data.results[i].DahA;
          }
        }
        _this.tableData = res.data.results;
      });
    },
    importexcel() {
      console.log("导入");
      this.dialogVisible = true;
    },
    reset() {
      this.year = new Date();
      this.city = "";
      this.type1 = "1";
      this.type2 = "Cd";
      this.options5 = this.options3;
      this.getzjs();
    },
    import1(t) {
        this.operateObj = t
        document.getElementById("uploadFile").click()
    },
    download(obj) {
        const _this = this;
        this.$axios({
          method: "post",
          url: obj.dowmLoadurl,

          responseType: "blob",
          headers: {
            Authorization: _this.token.toString(),
            "Content-Type": "application/json",
          },
        }).then(function (res) {
          const BLOB = res.data;
          // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
          const fileReader = new FileReader();
          // 开始读取指定的Blob中的内容。读取完成result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容

          if (BLOB) {
            // 此处判断是否有数据，也可以在此判断文件类型是否符合
            fileReader.readAsDataURL(BLOB);
          }
          fileReader.onload = (event) => {
            let a = document.createElement("a");
            //a.download = `出库明细表.xls`; // 自定义文件名
            a.download =obj.name+ ".xlsx"; // 使用默认的文件名
            a.href = event.target.result;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
          };
        });
    },
    // 上传
    uploadsample() {
        console.log("1111")
      var filelist = document.getElementById("uploadFile").files;
      console.log(filelist[0]);
      let params = new FormData();
      params.append("file", filelist[0]);
      var url = this.operateObj.url
        console.log(url)
      const _this = this;
      _this.$message({
        message: "正在更新数据，请稍等！",
        type: "success",
      });
      this.$axios({
        method: "put",
        url: url,
        data: params,
        headers: {
          Authorization: _this.token.toString(),
          "Content-Type": "multipart/form-data",
        },
      })
        .then(function (res) {
          console.log(res);
          if (res.status == 200) {
            _this.$message({
              message: "上传成功",
              type: "success",
            });
          } else {
            _this.$message.error("上传失败，请检查文件格式是否正确！");
          }
        })
        .catch(function (err) {
          _this.$message.error("上传失败，请检查文件格式是否正确！");
        });
      var fileinput = document.getElementById("uploadFile");
      fileinput.value = "";
    },
  },
  mounted() {
    this.username = this.$Cookie.get("username");
    this.token = this.$Cookie.get("token");
    this.year = new Date();
    // this.city = "上海市"
    this.type1 = "1";
    this.type2 = "Cd";
    this.options5 = this.options3;
    // this.getzjs()
  },
};
</script>
<style lang="scss">
.datagl {
  display: flex;
  flex-direction: column;
  height: 100%;

  .top {
    background-color: #fff;
    height: 80px;
    margin-bottom: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    padding: 0 20px;

    div {
      display: flex;
      align-items: center;
      margin-right: 8px;

      p {
        margin-right: 8px;
      }

      .el-select {
        width: 120px;
      }

      .el-input {
        width: 120px;
      }
    }
  }

  .bottom {
    background-color: #fff;
    flex: 1;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;
  }

  .importexcel {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;

    span {
      width: 200px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #66b1ff;

      color: #fff;
      cursor: pointer;
      margin-bottom: 20px;
    }

    p {
      margin-bottom: 20px;
      cursor: pointer;
    }

    p:hover {
      color: #66b1ff;
    }
  }
}
</style>